import Vue from "vue";
import { mapGetters } from "vuex";
import {
  formatDateTime,
  stringHelper,
  sizeHelper,
  partInfoHelper
} from "@/components/mixins";
import {
  DnFunctionButton,
  LoadingSpinner
} from "@/components/Elements"
import CurrencyText from "@/components/Elements/CurrencyText.vue";
import StockInformationPopover from "@/components/Elements/StockInformationPopover.vue";

/**
 * DiagramPartCard – Compact card for displaying a single part's details within
 * the diagram-based search results. Shows part code, description, pricing,
 * stock info, image thumbnail, and an "Add to Cart" action.
 */
export default Vue.extend({
  name: "DiagramPartCard",
  components: {
    CurrencyText,
    DnFunctionButton,
    LoadingSpinner,
    StockInformationPopover
  },
  mixins: [formatDateTime, stringHelper, sizeHelper, partInfoHelper],
  props: {
    /** Part object containing FullPartDetails, OemPartCode, etc. */
    part: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters([
      "facingWarehouse",
    ]),
  },
});
